import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User renamed a clip',
  name: 'renamed_clip',
  params: [
    {
      description: 'Id of renamed clip',
      name: 'clip_id',
      required: true,
      type: 'string',
    },
    {
      description: 'New clip title',
      name: 'new_clip_title',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
